/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Sub_NoneInputs */

const en_settings_sub_none = /** @type {(inputs: Settings_Sub_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`You're on the Free plan.`)
};

const id_settings_sub_none = /** @type {(inputs: Settings_Sub_NoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kamu di paket Free.`)
};

/**
* | output |
* | --- |
* | "You're on the Free plan." |
*
* @param {Settings_Sub_NoneInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const settings_sub_none = /** @type {((inputs?: Settings_Sub_NoneInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Sub_NoneInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_settings_sub_none(inputs)
	return en_settings_sub_none(inputs)
});